<div id="unsupportedBrowserSection" class="unsupported-browser-wrapper" *ngIf="showUnsupportedBrowser">
  <div class="unsupported-browser-container">
    <p>{{ 'message.unsupportedUserAgent' | translate:'PortalBase' | async  }}</p>
    <span class="unsupported-browser-btns buttonArea" >
      <button type="submit" id="acceptUnSupportedBrowserPolicyId" class="btn btn-primary btn-xs" (click)="hideNotification()">
        {{ 'vueCookiePolicy.understandBtn' | translate:'PortalBase' | async  }}
      </button>
    </span>
  </div>
</div>

<vue-login-header [hideLocaleSelect]="true" [transclude]="true">
    <vue-portal-locale-selector
            [locales]="locales | async"
            [selected]="selectedLocale"
            (localeChange)="localeChanged($event)"></vue-portal-locale-selector>
</vue-login-header>
<vue-navigation
    [accountMaintLink]="accountMaintenanceLink"
    [showAccountMaint]="true"
    [customHeaderDetail]="siteHeaderDetail"
    [firstTimeLaunch]="true"></vue-navigation>
<vue-cookie-policy></vue-cookie-policy>
<div id="main-content" vueMainContent>
    <vue-loading-indicator [loadingText]="'label.loading' | translate:'PortalBase' | async "></vue-loading-indicator>
    <vue-confirm-lose-changes-dialog></vue-confirm-lose-changes-dialog>
    <vue-timeout-dialog></vue-timeout-dialog>
    <div class="app-wrapper">
        <div class="app-container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<vue-footer></vue-footer>
